export default __webpack_public_path__ + "public/fonts/fontawesome-webfont.woff";